// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const GraphicHomeTestimonialLeft: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="200" height="430" viewBox="0 0 200 430" fill="currentColor">
            <polygon
                fill="#CCC"
                fillRule="evenodd"
                points="130.805 0 200 0 200 430 0 430"
                opacity=".33"
                transform="rotate(180 100 215)"
            />
        </svg>
    );
};

export default React.memo(GraphicHomeTestimonialLeft);
